const TEAM_CATEGORY_SCORES = {
  teamDynamics: 'TEAM_DYNAMICS',
  engineeringPerformance: 'ENGINEERING_PERFORMANCE',
  productDelivery: 'PRODUCT_DELIVERY',
  clientSatisfaction: 'CLIENT_SATISFACTION'
};

export default TEAM_CATEGORY_SCORES;
